import "./TasksProgressKPI.css";

import { OrganisationTypeConstants } from "../../../../constants";
import { TasksProgressKPIProps } from "../../../../models/workflow/TasksProgressKPI";
import { useAuth } from "../../../../useAuth";
import { Toggle } from "../../../forms";
import { Key } from "./components/Key/Key";
import { ProgressBar } from "./components/ProgressBar/ProgressBar";

export const TasksProgressKPI = ({ data, onToggle, toggleProgress }: TasksProgressKPIProps): JSX.Element => {
  const { currentUserType } = useAuth();
  const total =
    data.completedTasksCount +
    data.inReviewTasksCount +
    data.inProgressTasksCount +
    data.blockedTasksCount +
    data.todoTasksCount +
    data.unassignedTasksCount;

  const percentageComplete =
    total > 0 ? Math.min(100, Math.max(0, Math.round((data.completedTasksCount / total) * 100))) : 0;

  return (
    <div
      className={`TaskProgressKPIContainer ${
        currentUserType === OrganisationTypeConstants.ASSET_MANAGER ? "Rounded" : ""
      }`}
    >
      <div className="Header">
        <p className="body01">Progress</p>
        <div className="ToggleSection">
          <p className={`body03 ${toggleProgress ? "Inactive" : "Active"}`}>Phase</p>
          <Toggle value={toggleProgress} variant="primary" size="small" onChange={(e) => onToggle(e)} />
          <p className={`body03 ${toggleProgress ? "Active" : "Inactive"}`}>Overall</p>
        </div>
      </div>

      <div className="ProgressBarContainer">
        <div className="ProgressBarBorder">
          {total <= 0 ? (
            <ProgressBar
              completed={0}
              inReview={0}
              inProgress={0}
              blocked={0}
              todo={0}
              unassigned={100}
              currentUserType={currentUserType}
            />
          ) : (
            <ProgressBar
              completed={(data.completedTasksCount / total) * 100}
              inReview={(data.inReviewTasksCount / total) * 100}
              inProgress={(data.inProgressTasksCount / total) * 100}
              blocked={(data.blockedTasksCount / total) * 100}
              todo={(data.todoTasksCount / total) * 100}
              unassigned={(data.unassignedTasksCount / total) * 100}
              currentUserType={currentUserType}
            />
          )}
        </div>
        <div className="CompleteContainer">
          <div className="makeBold">
            <p className="body02">{percentageComplete} %</p>
          </div>
          <div className="makeLight">
            <p className="body02">complete</p>
          </div>
        </div>
      </div>
      <Key />
    </div>
  );
};
